document.addEventListener('DOMContentLoaded', function () {
  const faqSections = document.querySelectorAll('.about-faq-premium');

  faqSections.forEach((section) => {
    const triggers = section.querySelectorAll('[data-faq-trigger]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const item = trigger.closest('.about-faq-premium__item');
        const content = item.querySelector('[data-faq-content]');
        const isOpen = trigger.classList.contains('is-open');

        triggers.forEach((otherTrigger) => {
          const otherItem = otherTrigger.closest('.about-faq-premium__item');
          const otherContent = otherItem.querySelector('[data-faq-content]');

          otherTrigger.classList.remove('is-open');
          otherTrigger.setAttribute('aria-expanded', 'false');

          if (otherContent) {
            otherContent.classList.remove('is-open');
            otherContent.hidden = true;
          }
        });

        if (!isOpen) {
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');

          if (content) {
            content.hidden = false;
            content.classList.add('is-open');
          }
        }
      });
    });
  });
});